import { render, staticRenderFns } from "./contractsexim.vue?vue&type=template&id=dec734ca&"
import script from "./contractsexim.vue?vue&type=script&lang=js&"
export * from "./contractsexim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports